import React, { createContext, useCallback, useContext, useState, type ReactNode } from "react"
import { API_ROUTES } from "../configuration/RoutesApi"
import { GetRequest } from "../services/ApiClientService"
import type { TimeClockStatus } from "../Objects/TimeClock/TimeClockStatus"

interface TimeClockStatusContextData {
  status: TimeClockStatus | undefined
  isLoading: boolean
  refresh: () => Promise<TimeClockStatus | undefined>
}

const TimeClockStatusContext = createContext<TimeClockStatusContextData | undefined>(undefined)

interface TimeClockStatusProviderProps {
  children: ReactNode
}

export const TimeClockStatusProvider: React.FC<TimeClockStatusProviderProps> = ({ children }) => {
  const [status, setStatus] = useState<TimeClockStatus | undefined>(undefined)

  const [isLoading, setIsLoading] = useState(false)

  const refresh = useCallback(async () => {
    setIsLoading(true)

    try {
      const response = await GetRequest<TimeClockStatus>(API_ROUTES.TIME_CLOCK.ME)

      if (!response.success) return undefined

      setStatus(response.data)

      return response.data
    } finally {
      setIsLoading(false)
    }
  }, [])

  return (
    <TimeClockStatusContext.Provider value={{ status, isLoading, refresh }}>{children}</TimeClockStatusContext.Provider>
  )
}

export const useTimeClockStatus = (): TimeClockStatusContextData => {
  const context = useContext(TimeClockStatusContext)

  if (!context) {
    throw new Error("useTimeClockStatus deve ser usado dentro de um TimeClockStatusProvider")
  }

  return context
}
